import { createTheme } from '@mantine/core';

/**
 * Professional earth-toned palette - fitting for a title-examination tool.
 * Primary: deep green (stable, legal feel). Gray is slightly warm.
 */
export const theme = createTheme({
  primaryColor: 'pine',
  primaryShade: { light: 7, dark: 5 },
  defaultRadius: 'md',
  fontFamily: 'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '1.75rem', lineHeight: '1.25' },
      h2: { fontSize: '1.375rem', lineHeight: '1.3' },
      h3: { fontSize: '1.125rem', lineHeight: '1.4' },
    },
  },
  colors: {
    pine: [
      '#e8f3ec',
      '#c9e3d1',
      '#a5d1b1',
      '#7abd8d',
      '#56ac71',
      '#3e9c5d',
      '#2f8b4f',
      '#267140',
      '#1f5a34',
      '#18452a',
    ],
  },
  components: {
    Button: { defaultProps: { size: 'sm' } },
    TextInput: { defaultProps: { size: 'sm' } },
    Select: { defaultProps: { size: 'sm' } },
    Textarea: { defaultProps: { size: 'sm' } },
    Table: { defaultProps: { highlightOnHover: true, verticalSpacing: 'xs' } },
  },
});
